class LayoutChildComponentData {
	constructor() {
		this.enabled = true;
	}
}

export { LayoutChildComponentData };
